import {
  SHOW_PAGE,
  GO_BACK,
  GO_BACK_DONE,
  HIDE_ALL,
} from './actions';

const showPage = (state, action) => ({
  ...state,
  displayedPages: [...state.displayedPages, action.slug],
});

const goBack = state => ({
  ...state,
  goingBack: true,
  displayedPages: state.displayedPages.slice(0, state.displayedPages.length - 1),
});

const goBackDone = state => ({
  ...state,
  goingBack: false,
});

const hideAll = state => ({
  ...state,
  displayedPages: [],
  goingBack: true,
});

const reducer = {
  [SHOW_PAGE]: showPage,
  [GO_BACK]: goBack,
  [GO_BACK_DONE]: goBackDone,
  [HIDE_ALL]: hideAll,
};

const initialState = {
  displayedPages: [],
  pages: [],
  goingBack: false,
};

export default (state = initialState, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
